export const version = '5.1.4';
export const buildTime = 'Wed May 20 2026 11:09:41 GMT+0200 (Central European Summer Time)';
export const sourceUrl = 'https://github.com/UUDigitalHumanitieslab/gretel/tree/364c454f3a97a357752a36ebf78124ebdf46cbd8';
